import { axiosInstance, KASHU_GLOBAL_ON_ID } from "@/axios/interceptors";

const blobToDataUrl = (blob: Blob): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const { result } = reader;
			if (typeof result === "string") {
				resolve(result);
			} else {
				reject(new Error("FileReader type error"));
			}
		};
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
};

export async function getWhiteLabelLogo(logoPath: string): Promise<string> {
	const response = await axiosInstance.get("/download-file", {
		params: {
			path: logoPath,
			global_on_id: KASHU_GLOBAL_ON_ID,
			cache: true,
		},
		responseType: "blob",
	});

	return await blobToDataUrl(response.data);
}
